import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  ConfirmToDeleteAccountInitialValues,
  ConfirmToDeleteAccountInterface,
} from '../../models/dashboard/settings/confirm-to-delete-account';
import {
  ReasonToDeleteAccountInitialValues,
  ReasonToDeleteAccountInterface,
} from '../../models/dashboard/settings/reason-to-delete-account';

interface IInitialState {
  deleteReason: ReasonToDeleteAccountInterface;
  confirmDelete: ConfirmToDeleteAccountInterface;
}
const initialState: IInitialState = {
  deleteReason: ReasonToDeleteAccountInitialValues,
  confirmDelete: ConfirmToDeleteAccountInitialValues,
};

const deleteAccountSlice = createSlice({
  name: 'deleteAccount',
  initialState,
  reducers: {
    setDeleteReasonSlider(state, action: PayloadAction<ReasonToDeleteAccountInterface>) {
      state.deleteReason = action.payload;
    },
    setConfirmDeleteSlider(state, action: PayloadAction<ConfirmToDeleteAccountInterface>) {
      state.confirmDelete = action.payload;
    },
  },
});

export const deleteAccountAction = deleteAccountSlice.actions;
export default deleteAccountSlice.reducer;
